import { atom } from 'recoil';

export const mainFunctionListState = atom({
  key: 'mainFunctionListState',
  default: [],
});

export const commonMainFunctionListState = atom({
  key: 'commonMainFunctionListState',
  default: [],
});

export const heroBannerListState = atom({
  key: 'heroBannerListState',
  default: [],
});

export const adBannerListState = atom({
  key: 'adBannerListState',
  default: [],
});

export const employeeBenefitOpenState = atom({
  key: 'employeeBenefitOpenState',
  default: false,
});

export const employeeBenefitMessageState = atom({
  key: 'employeeBenefitMessageState',
  default: '',
});

export const employeeBenefitBrandCountState = atom({
  key: 'employeeBenefitBrandCountState',
  default: '',
});

export const employeeBenefitBrandNameState = atom({
  key: 'employeeBenefitBrandNameState',
  default: '',
});

export const mallListState = atom({
  key: 'mallListState',
  default: [],
});

export const mainBestReviewListState = atom({
  key: 'mainBestReviewListState',
  default: [],
});
